import { useTranslation } from "react-i18next"

const useReloadWarning = (display = true) => {
  const { t } = useTranslation()

  const handleReloadWarning = (event, message = null) => {
    if (!display) {
      return true
    }

    const warning =
      message || t("Are you sure? Changes that you made may not be saved.")

    if (!window.confirm(warning)) {
      event.preventDefault()
    }
  }

  return { handleReloadWarning }
}

export default useReloadWarning
